//Bad things will happen if you change the order of these...
export enum UserRoleType {
    Customer,
    Admin
}